<template>
  <div>
    <button @click="makeRequest">ดึงข้อมูล transaction</button>
    <!-- <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>ชื่อเกมส์</th>
          <th>รอบเกมส์</th>
          <th>แทง</th>
          <th>ผลแพ้ชนะ</th>
          <th>จำนวนก่อนเดิมพัน</th>
          <th>จำนวนหลังการเดิมพัน</th>
          <th>เวลาที่เดิมพัน</th>
        </tr>
      </thead>
      <tbody v-if="transactions.length > 0">
        <tr
          v-for="(transaction, index) in transactions"
          :key="index"
        >
          <td>{{ transaction.gameName }}</td>
          <td>{{ transaction.gameRound }}</td>
          <td>{{ transaction.bet }}</td>
          <td>{{ transaction.winlose }}</td>
          <td>{{ transaction.balance.before }}</td>
          <td>{{ transaction.balance.after }}</td>
          <td>{{ transaction.timestamp }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="7">
            <center>
              ไม่พบข้อมูล transaction
            </center>
          </td>
        </tr>
      </tbody>
    </table> -->
    <vuetable
      ref="vuetable"
      :api-mode="false"
      :fields="tableField"
      :per-page="perPage"
			:data-manager="dataManager"
      :css="tableCss.table"
      pagination-path="pagination"
	    @vuetable:pagination-data="onPaginationData"
    />
    <div>
      <vuetable-pagination
        ref="pagination"
        :css="tableCss.pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import _ from "lodash";

export default {
  name: 'PgslotHistory',
  components: {
    Vuetable,
    VuetablePagination
  },
  data: () => ({
    transactions: [],
    perPage: 10,
  }),
  props: {
    username: {
      type: String,
      required: true,
    },
    timestamp: {
      type: Number | String,
      default: Date.now(),
    },
    startFrom: {
      type: String,
      enum: ['Deposit', 'Withdraw'],
    },
  },
  computed: {
    transactionUrl() {
      return `/wallet/amb/transactions`
    },
    tableCss() {
      return {
        table: {
          tableClass: 'table table-striped table-bordered'
        },
        pagination: {
          infoClass: 'pull-left mb-',
          wrapperClass: 'vuetable-pagination pull-right pagination',
          activeClass: 'btn-primary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      };
    },
    tableField() {
      return [
        {
          name: 'gameName',
          title: 'ชื่อเกมส์',
        },
        {
          name: 'gameRound',
          title: 'รอบเกมส์',
        },
        {
          name: 'bet',
          title: 'แทง',
        },
        {
          name: 'winlose',
          title: 'ผลแพ้ชนะ',
        },
        {
          name: 'balance.before',
          title: 'จำนวนก่อนเดิมพัน',
        },
        {
          name: 'balance.after',
          title: 'จำนวนหลังการเดิมพัน',
        },
        {
          name: 'timestamp',
          title: 'เวลาที่เดิมพัน',
        },
      ]
    },
  },
  methods: {
    async makeRequest() {
      const { data } = await axios.post(this.transactionUrl, {
        username: this.username,
        timestamp: this.timestamp,
      }, {
        headers: {
          'X-CSRF-TOKEN': window.App.csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': 'Bearer ' + window.App.jwtToken
        }
      });
      this.transactions = [...data.data.transactions];
    },
    dataManager(sortOrder, pagination) {
      if (this.transactions.length < 1) return;

      let local = this.transactions;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      );
      console.log('pagination:', pagination)
      let from = pagination.from - 1;
      let to = from + this.perPage;

      return {
        pagination: pagination,
        data: _.slice(local, from, to)
      };
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  },
  watch: {
    transactions(newVal, oldVal) {
      this.$refs.vuetable.refresh();
    }
  },
}
</script>

<style scoped>
.pagination {
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/PgSlotHistory.vue